export const MalianCows = ({ cowCount }) => {
    return (
        <div className={`malianCounter h-12 w-[7.5rem] ${cowCount == 0 && 'cowCounterEmpty'} ${cowCount == 20 && 'cowCounterFull'}`} style={{ color: "#F7D79E" }} >
            <h1 className="absolute h-12 ml-2 leading-[3rem] w-16 text-center">{cowCount} / 20</h1>
            <img className='absolute w-12 h-12 ml-[4.5rem]' src="/building_cattle_ranch.png" />
            <img className='h-12 w-[7.5rem] absolute -z-10' src="/sheepCounter/background.png" />
        </div>
    )
}